import {
  constFunction,
  constString,
  escapeDots,
  list,
  opConcat,
  opMap,
  opPick,
  opRunHistory,
  opRunSummary,
  typedDict,
  varNode,
} from '@wandb/weave/core';

import {envIsLocal} from '../../config';
import {isBetaFeatureEnabled} from '../../util/useBetaFeature';

export interface WeaveConfig {
  panel2Config?: any;
  defaultWorkspaceState?: {
    panel2Config?: any;
    key: string;
    keyType: string;
  };
}

export function weavePanelForWeaveKey(
  key: string,
  keyType: string
): WeaveConfig {
  // var name does not matter, PanelExpression will auto-replace.
  // Using something unique & ugly to force out errors.
  const panel2Config: any = {};
  const vNode = varNode(list('run'), 'runs');
  if (keyType === 'wb_trace_tree') {
    panel2Config.exprAndPanelLocked = true;
    panel2Config.exp = opConcat({
      arr: opMap({
        arr: vNode,
        mapFn: constFunction({row: typedDict({})}, ({row}) => {
          return opRunHistory({
            run: row,
          });
        }),
      }),
    });
    panel2Config.panelId = 'wb_trace_tree-traceDebuggerFromRunHistory';
    panel2Config.panelConfig = {
      traceKey: key,
    };
  } else if (
    [
      'table-file',
      'incremental-table-file',
      'partitioned-table',
      'joined-table',
    ].includes(keyType)
  ) {
    if (isBetaFeatureEnabled('weave0', undefined, undefined) && envIsLocal) {
      // Local integration is multiple layers of broken in using opRunHistory and the stepper panel since it uses Weave0.
      // * The history keys does not include the table
      // * Even if the table is included, the keys types are such that we cannot correctly register the stepper keys
      // Since Weave0 is deprecated, fallback to opRunSummary here to ensure that the panel at least renders the table.
      panel2Config.exp = opPick({
        obj: opRunSummary({run: vNode}),
        key: constString(escapeDots(key)),
      });
    } else {
      panel2Config.exp = opRunHistory({run: vNode});
      panel2Config.panelId = 'panel-stepper';
      panel2Config.panelConfig = {
        workingKeyAndType: {
          key: key,
          type: keyType,
        },
        workingSliderKey: '_step',
        workingPanelId: 'merge.table',
      };
    }
  } else {
    const tableNode = opPick({
      obj: opRunSummary({run: vNode}),
      key: constString(escapeDots(key)),
    });
    panel2Config.exp = tableNode;
  }

  return {
    panel2Config,
    defaultWorkspaceState: {
      panel2Config,
      key,
      keyType,
    },
  };
  // Uncomment the below to auto-inject the table merge. For now, I
  // prefer not auto-injecting, but this may change as we get feedback.
  // const newExp = callOp(Panel2.panelIdToPanelOpName('merge'), {
  //   input: runTableNode,
  //   config: Op.constNodeUnsafe('any', {}),
  // });

  // return {
  //   panel2Config: {exp: newExp},
  // };
}
